import { RowInfo } from '../models/row-info';

export const dRows = (): RowInfo[][] => [
  d1Rows(),
  d2Rows(),
  d3Rows(),
  d4Rows(),
  d5Rows(),
];

const d1Rows = (): RowInfo[] => [
  {
    description: '',
    options: [
      { view: 'Super senior', value: 5 },
      { view: 'Privilegio first lien', value: 4 },
      { view: 'Privilegio second lien', value: 3 },
      { view: 'Chirografario', value: 2 },
      { view: 'Subordinato', value: 1 },
      { view: 'N/A', value: 0 },
    ],
    kriWeight: 100,
  },
];

const d2Rows = (): RowInfo[] => [
  {
    description: '',
    options: [
      { view: 'Super senior', value: 5 },
      { view: 'Privilegio first lien', value: 4 },
      { view: 'Privilegio second lien', value: 3 },
      { view: 'Chirografario', value: 2 },
      { view: 'Subordinato', value: 1 },
      { view: 'N/A', value: 0 },
    ],
    kriWeight: 100,
  },
];

const d3Rows = (): RowInfo[] => [
  {
    description: '',
    options: [
      { view: 'Finanziamento circolante', value: 5 },
      { view: 'Finanziamento capex per crescita', value: 3 },
      {
        view: 'Refinancing (rimborso di debiti pregressi scaduti)',
        value: 1,
      },
      { view: 'N/A', value: 0 },
    ],
    kriWeight: 100,
  },
];

const d4Rows = (): RowInfo[] => [
  {
    description: '',
    options: [
      { view: '>90%', value: 5 },
      { view: '>65% - <=90%', value: 4 },
      { view: '>35% - <=65%', value: 3 },
      { view: '>10% - <=35%', value: 2 },
      { view: '<=10%', value: 1 },
      { view: 'N/A', value: 0 },
      { view: 'N/A', value: 0 },
    ],
    kriWeight: 100,
  },
];

const d5Rows = (): RowInfo[] => [
  {
    description: '',
    options: [
      { view: 'Alta', value: 5 },
      { view: 'Medio-alta', value: 4 },
      { view: 'Media', value: 3 },
      { view: 'Medio-bassa', value: 2 },
      { view: 'Bassa', value: 1 },
      { view: 'N/A', value: 0 },
    ],
    kriWeight: 100,
  },
];
